import { useOpenEditPlaceLevelModal } from '../../routes/modals/modalsActions'
import { usePlaceTypePermission } from '../../helpers/placeTypes'
import { useRemovePlaceLevels } from './_requests/removePlaceLevels'
import { useRouteParam } from '../../routes/helpers/useParam'

export const usePlaceLevelEditAction = item => {
  const openEditModal = useOpenEditPlaceLevelModal()
  // const canEdit = usePlaceTypePermission('setup' + item?.type)
  const canEdit = true

  return {
    click: () => openEditModal({ id: item?.id, type: item?.type }),
    hasPermission: canEdit
  }
}

export const usePlaceLevelRemoveAction = item => {
  // const canDelete = usePlaceTypePermission('setup' + item?.type)
  const canDelete = true
  const [deleteItems, { loading }] = useRemovePlaceLevels()

  return {
    click: () => deleteItems([item.id]),
    hasPermission: canDelete
  }
}

export const usePlaceLevelsRemoveAction = ids => {
  const entity = useRouteParam('entity')
  const canDelete = true
  const [deleteItems, { loading }] = useRemovePlaceLevels()

  return {
    click: () => deleteItems(ids),
    hasPermission: canDelete
  }
}
